import React from "react";
import { useTranslation } from "react-i18next";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

export function PanelDisplayModeToggle({
  mode = "default",
  onToggle,
  className = "",
  disabled = false,
}) {
  const { t } = useTranslation();
  const isHrTrend = mode === "hrTrend";
  const label = isHrTrend
    ? t("liveTrainingPanelModeDefault") || "Show player info"
    : t("liveTrainingPanelModeHrTrend") || "Show heart rate trend";

  return (
    <button
      type="button"
      className={`lt-panel-mode-toggle${className ? ` ${className}` : ""}`}
      onClick={onToggle}
      disabled={disabled}
      aria-pressed={isHrTrend}
      aria-label={label}
      title={label}
    >
      {isHrTrend ? (
        <PersonOutlineIcon fontSize="small" />
      ) : (
        <ShowChartOutlinedIcon fontSize="small" />
      )}
    </button>
  );
}

export default PanelDisplayModeToggle;
